import * as React from "react"
const SvgGrowingMini = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M1.75 12.633a.964.964 0 0 1-.033-1.4l3.266-3.216a1.9 1.9 0 0 1 1.384-.584q.8 0 1.383.584L8.9 9.15l2.7-2.717h-.783a.95.95 0 0 1-.694-.288.94.94 0 0 1-.29-.691q0-.404.29-.696a.94.94 0 0 1 .694-.291h3.166q.406 0 .694.289.29.29.29.694V8.6q0 .405-.289.694a.94.94 0 0 1-.691.29.96.96 0 0 1-.695-.285.92.92 0 0 1-.292-.682v-.8l-2.717 2.716a1.9 1.9 0 0 1-1.383.584 1.9 1.9 0 0 1-1.383-.584l-1.15-1.15-3.234 3.25q-.3.3-.691.3a.95.95 0 0 1-.692-.3" />
  </svg>
)
export default SvgGrowingMini
